import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
.set('conceptos', new Immutable.List([]))
.set('concepto', new Immutable.Map({}))

/* Types */
export const ACTION_GET_CONCEPTS = 'ACTION_GET_CONCEPTS'
export const ACTION_GET_CONCEPT = 'ACTION_GET_CONCEPT'

/* Reducer */
export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_GET_CONCEPTS:
      return state.set('conceptos', new Immutable.List(action.Obj))
    case ACTION_GET_CONCEPT:
        return state.set('concepto', new Immutable.Map(action.Obj))
    default:
      return state
  }
}

/* Action Creators */
export const newConcept = form => {
  Utils.clearNullAndEmpty(form)
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/newConcept',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(() => {
        dispatch(isLoading(false))
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getConcepts = () => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getConcepts',
      method: 'POST',
      data: {},
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_CONCEPTS, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getConceptById = idConcepto => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getConceptById',
      method: 'POST',
      data: { idConcepto },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_CONCEPT, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updateConcept = form => {
  Utils.clearNullAndEmpty(form)
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updateConcept',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const deleteConcept = id => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/deleteConcept',
      method: 'POST',
      data: { id },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        // dispatch({ type: ACTION_CONCEPT, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const searchConcept = form => {
  Utils.clearNullAndEmpty(form)

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/searchParamConcept',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_CONCEPTS, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const clearConcept = () => {
  return dispatch => {
    dispatch({ type: ACTION_GET_CONCEPTS, Obj: [] })
    dispatch({ type: ACTION_GET_CONCEPT, Obj: {} })
  }
}



// WEBPACK FOOTER //
// ./src/modules/Catalogs/Concepts/Concept.js